<template>
  <div class="xb-section-container">
    <h2 class="underline">Drafts</h2>

    <b-notification
      class="xb-notification xb-notification-icon"
      type="is-danger"
      :active="notification.isActive"
      has-icon
      :message="notification.message"
      @close="notification.isActive = false"
    />

    <advanced-table
      v-if="tableData.length > 0"
      :is-fetching="isFetching"
      :columns="columns"
      :table-data="tableData"
      :paginated="false"
      :sticky="true"
    ></advanced-table>

    <span v-else>You have no drafts at the moment</span>
  </div>
</template>

<script>
const mapState = window.Vuex.mapState;

import baseService from "./../../../services/index";
import { format, parseISO } from "date-fns";

export default {
  name: "Drafts",
  props: {
    profileType: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
    ...mapState({
      apiConfig: state => state.config.configurationData,
      accessToken: state => state.auth.accessToken
    }),
    headerOptions() {
      return {
        headers: {
          Authorization: `Bearer ${this.accessToken}`
        }
      };
    }
  },
  data: function() {
    const _this = this;
    return {
      notification: {
        isActive: false,
        message: ""
      },
      applicationListRoutePair: [
        {
          appName: "Pre-Application Assessment",
          path: rowData => {
            const ticketRefNo = rowData.referenceNo;
            const applicationStatus = rowData.activityGroup;

            if (applicationStatus === "Draft") {
              window.location.href = `/aceas/pre-application/edit-form/${ticketRefNo}`;
            } else {
              window.location.href = `/aceas/pre-application/view-pre-application-detail/${ticketRefNo}`;
            }
          }
        },
        {
          appName: "EA Licence - New",
          path: rowData => {
            const ticketRefNo = rowData.referenceNo;
            const applicationStatus = rowData.activityGroup;

            if (applicationStatus === "Pending EA Submission") {
              window.location.href = `/aceas/EA-Management/new-EA-licence-application/${ticketRefNo}/intro`;
            } else if (applicationStatus === "Draft") {
              window.location.href = `/aceas/EA-Management/new-EA-licence-application/${ticketRefNo}/intro`;
            } else if (applicationStatus === "Pending Initiation") {
              window.location.href = `/aceas/EA-Management/new-EA-licence-application/initiation-intro`;
            } else {
              window.location.href = `/aceas/EA-Management/new-EA-licence-application/${ticketRefNo}/application-information`;
            }
          }
        },
        {
          appName: "EA License - Additional of KEO (Change KEO)",
          path: rowData => {
            const ticketRefNo = rowData.referenceNo;
            const applicationStatus = rowData.activityGroup;
            const previousWorkflowStatus = rowData.previousWorkflowStatus;

            if (_this.profileType === 1) {
              if (applicationStatus === "Draft" && !previousWorkflowStatus) {
                window.location.href = `/aceas/EA-Management/addition-of-KEO/initiation-form?appId=${ticketRefNo}`;
              } else if (
                applicationStatus === "Draft" &&
                (previousWorkflowStatus == "Pending EA Submission" ||
                  previousWorkflowStatus == "Pending EA Resubmission")
              ) {
                window.location.href = `/aceas/EA-Management/addition-of-KEO/${ticketRefNo}/form`;
              } else if (applicationStatus === "Pending EA Submission") {
                window.location.href = `/aceas/EA-Management/addition-of-KEO/${ticketRefNo}/form`;
              } else {
                window.location.href = `/aceas/EA-Management/addition-of-KEO/${ticketRefNo}/application-information`;
              }
            } else {
              if (
                applicationStatus === "Draft" &&
                (previousWorkflowStatus == "Pending KEO Submission" ||
                  previousWorkflowStatus == "Pending KEO Resubmission")
              ) {
                window.location.href = `/aceas/EA-Management/addition-of-KEO/${ticketRefNo}/form-keo-application`;
              } else if (applicationStatus === "Pending KEO Submission") {
                window.location.href = `/aceas/EA-Management/addition-of-KEO/${ticketRefNo}/introduction-keo-application`;
              } else {
                window.location.href = `/aceas/EA-Management/addition-of-KEO/${ticketRefNo}/keo-application-information`;
              }
            }
          }
        },
        {
          appName: "EA License - Removal of KEO (Change KEO)",
          path: rowData => {
            const ticketRefNo = rowData.referenceNo;
            const applicationStatus = rowData.activityGroup;
            if (applicationStatus === "Draft") {
              window.location.href = `/aceas/EA-Management/removal-of-KEO/form?appId=${ticketRefNo}`;
            } else {
              window.location.href = `/aceas/EA-Management/removal-of-KEO/${ticketRefNo}/application-information`;
            }
          }
        },
        {
          appName: "EA Licence - Addition of Directors and Partners",
          path: rowData => {
            const ticketRefNo = rowData.referenceNo;
            const activityGroup = rowData.activityGroup;

            if (_this.profileType === 2) {
              if (
                activityGroup == "Pending Submission" ||
                activityGroup == "Draft"
              ) {
                this.checkAdditionOfDirparRecommendationData(ticketRefNo).then(
                  response => {
                    if (response) {
                      window.location.href = `/aceas/EA-Management/addition-of-director-partner-application/${ticketRefNo}/information`;
                    } else {
                      window.location.href = `/aceas/EA-Management/addition-of-director-partner-application/${ticketRefNo}/intro`;
                    }
                  }
                );
              } else {
                window.location.href = `/aceas/EA-Management/addition-of-director-partner-application/${ticketRefNo}/information`;
              }
            } else {
              window.location.href = `/aceas/EA-Management/addition-of-director-partner-application/${ticketRefNo}/information`;
            }
          }
        },
        {
          appName: "EA Licence - Removal of Directors and Partners",
          path: rowData => {
            const ticketRefNo = rowData.referenceNo;
            window.location.href = `/aceas/EA-Management/removal-of-director-partner-application/${ticketRefNo}/information`;
          }
        },
        {
          appName: "EA Licence - Renewal",
          path: rowData => {
            const ticketRefNo = rowData.referenceNo;
            const applicationStatus = rowData.activityGroup;
            if (applicationStatus === "Pending EA Submission") {
              window.location.href = `/aceas/EA-Management/EA-licence-renewal/${ticketRefNo}/intro`;
            } else if (applicationStatus === "Draft") {
              window.location.href = `/aceas/EA-Management/EA-licence-renewal/${ticketRefNo}/intro`;
            } else {
              window.location.href = `/aceas/EA-Management/EA-licence-renewal/${ticketRefNo}/application-information`;
            }
          }
        },
        {
          appName: "EA Licence - Non Renewal",
          path: rowData => {
            const ticketRefNo = rowData.referenceNo;
            const activityGroup = rowData.activityGroup;

            if (
              activityGroup === "Pending EA Resubmission" ||
              activityGroup === "Pending EA Submission"
            ) {
              window.location.href = `/aceas/EA-Management/EA-licence-non-renewal/intro`;
            } else if (activityGroup === "Draft") {
              window.location.href = `/aceas/EA-Management/director-partner-renewal/intro`;
            } else {
              window.location.href = `/aceas/EA-Management/EA-licence-non-renewal/${ticketRefNo}/application-information`;
            }
          }
        },
        {
          appName: "EA Licence - Directors and Partners Renewal",
          path: rowData => {
            const ticketRefNo = rowData.referenceNo;
            const activityGroup = rowData.activityGroup;

            if (_this.profileType === 1) {
              window.location.href = `/aceas/EA-Management/director-partner-renewal-application-information/${ticketRefNo}`;
            } else if (activityGroup === "Draft") {
              window.location.href = `/aceas/EA-Management/director-partner-renewal/${ticketRefNo}/intro`;
            } else if (activityGroup === "Pending Applicant Submission") {
              window.location.href = `/aceas/EA-Management/director-partner-renewal/${ticketRefNo}/intro`;
            } else {
              window.location.href = `/aceas/EA-Management/director-partner-renewal/${ticketRefNo}/application-information`;
            }
          }
        },
        {
          appName: "EA Licence - Cancellation",
          path: rowData => {
            const ticketRefNo = rowData.referenceNo;
            window.location.href = `/aceas/EA-Management/cancellation/${ticketRefNo}`;
          }
        },
        {
          appName: "RES Registration - New & Returning",
          path: rowData => {
            const ticketRefNo = rowData.referenceNo;
            if (_this.profileType == 1) {
              window.location.href = `/aceas/RES-Management/new-and-returning/${ticketRefNo}/application-information`;
            } else {
              const listStatusRedirectToForm = [
                "Pending RES Submission",
                "Draft"
              ];
              // const statusBeforeSubmitToEA = [
              //   "Pending Initiation",
              //   "Pending RES Submission"
              // ];

              const applicationStatus = rowData.activityGroup;
              // const previousWorkflowStatus = rowData.previousWorkflowStatus;
              if (
                listStatusRedirectToForm.includes(applicationStatus)
                //  &&
                // statusBeforeSubmitToEA.includes(previousWorkflowStatus)
              ) {
                this.checkNewReturningRecommendationData(ticketRefNo).then(
                  response => {
                    if (response) {
                      window.location.href = `/aceas/RES-Management/new-and-returning/${ticketRefNo}/application-information`;
                    } else {
                      window.location.href = `/aceas/RES-Management/new-and-returning/${ticketRefNo}/intro`;
                    }
                  }
                );
              } else {
                window.location.href = `/aceas/RES-Management/new-and-returning/${ticketRefNo}/application-information`;
              }
            }
          }
        },
        {
          appName: "RES Registration - Switching",
          path: rowData => {
            const ticketRefNo = rowData.referenceNo;
            if (_this.profileType == 1) {
              window.location.href = `/aceas/RES-Management/switching/incoming-applications/${ticketRefNo}/application-information`;
            } else {
              const applicationStatus = rowData.activityGroup;
              if (
                applicationStatus == "Draft" ||
                applicationStatus == "Pending RES Submission"
              ) {
                _this
                  .checkRecommendationData(
                    ticketRefNo,
                    _this.apiConfig.common_module.appManagement
                      .getRecommendationDataOnSwitching
                  )
                  .then(response => {
                    if (response) {
                      window.location.href = `/aceas/RES-Management/switching/${ticketRefNo}/application-information`;
                    } else {
                      window.location.href = `/aceas/RES-Management/switching/application/${ticketRefNo}/introduction-page`;
                    }
                  });
              } else {
                window.location.href = `/aceas/RES-Management/switching/${ticketRefNo}/application-information`;
              }
            }
          }
        },
        {
          appName: "RES Registration - Renewal",
          path: rowData => {
            const ticketRefNo = rowData.referenceNo;
            const status = rowData.activityGroup;
            if (_this.profileType === 1) {
              window.location.href = `/aceas/RES-Management/renewal/${ticketRefNo}/application-information`;
            } else {
              if (status == "Draft" || status == "Pending RES Submission") {
                _this
                  .checkRecommendationData(
                    ticketRefNo,
                    _this.apiConfig.common_module.appManagement
                      .getRecommendationDataOnResRenewal
                  )
                  .then(response => {
                    if (response) {
                      window.location.href = `/aceas/RES-Management/renewal/${ticketRefNo}/application-information`;
                    } else {
                      window.location.href = `/aceas/RES-Management/renewal/${ticketRefNo}/intro`;
                    }
                  });
              } else {
                window.location.href = `/aceas/RES-Management/renewal/${ticketRefNo}/intro`;
              }
            }
          }
        },
        {
          appName: "RES Registration - Cancellation",
          path: rowData => {
            const ticketRefNo = rowData.referenceNo;
            window.location.href = `/aceas/RES-Management/cancellation/${ticketRefNo}/application-information`;
          }
        },
        {
          appName: "RES Registration - Non Renewal",
          path: rowData => {
            const ticketRefNo = rowData.referenceNo;
            const status = rowData.activityGroup;
            if (_this.profileType === 1) {
              window.location.href = `/aceas/RES-Management/non-renewal/${ticketRefNo}/application-information`;
            } else {
              if (status == "Draft" || status == "Pending RES Submission") {
                window.location.href = `/aceas/RES-Management/non-renewal/${ticketRefNo}/intro`;
              }
              window.location.href = `/aceas/RES-Management/non-renewal/${ticketRefNo}/application-information`;
            }
          }
        }
      ],
      isFetching: false,
      columns: [
        {
          id: 1,
          label: "Application Type",
          dataCell: "applicationName",
          props: {
            sortable: false
          }
        },
        {
          id: 2,
          label: "Creation Date and Time",
          dataCell: "initiationDate",
          formatter: initiationDate =>
            format(parseISO(initiationDate), "dd/MM/yyy HH:mm:ss") || "-",
          props: {
            sortable: false
          }
        },
        {
          id: 3,
          label: "Status",
          dataCell: "activityGroup",
          props: {
            sortable: false
          }
        },
        {
          id: 4,
          label: "Actions",
          type: "action",
          uniqueField: "id",
          items: [
            {
              id: 0,
              title: "View",
              icon: "eye",
              "icon-pack": "fa",
              events: data => ({
                click: function() {
                  _this.redirectToRespectiveApp(data);
                }
              })
            }
          ]
        }
      ],
      tableData: []
    };
  },
  mounted() {
    this.fetchTableData();
  },
  methods: {
    redirectToRespectiveApp(data) {
      const applicationData = this.applicationListRoutePair.find(
        pair => data.applicationName == pair.appName
      );

      if (applicationData) {
        applicationData.path(data);
      }
    },
    fetchTableData() {
      const endpoint = this.apiConfig.common_module.appManagement
        .getGeneralDraftApplicationsEndpoint;

      baseService(
        endpoint,
        {},
        this.handleFetchTableDataSuccess,
        this.handleFailed,
        this.headerOptions
      );
    },
    handleFetchTableDataSuccess(response) {
      this.tableData = response.data.data;
    },
    handleFailed(e) {
      this.$set(this.notification, "isActive", true);
      this.$set(
        this.notification,
        "message",
        this.$_globalMixin_errorMessage(e)
      );
    },
    checkRecommendationData(id, endpoint) {
      const payload = {
        id: decodeURIComponent(id)
      };

      return new Promise(resolve => {
        baseService(
          endpoint,
          payload,
          ({ data: { data } }) => resolve(data.remarks),
          () => resolve(null),
          this.headerOptions
        );
      });
    },
    checkNewReturningRecommendationData(id) {
      const payload = {
        id: decodeURIComponent(id)
      };

      const endpoint = this.apiConfig.common_module.appManagement
        .getRecommendationDataOnNewReturning;

      return new Promise(resolve => {
        baseService(
          endpoint,
          payload,
          ({ data: { data } }) => resolve(data.remarks),
          () => resolve(null),
          this.headerOptions
        );
      });
    },
    checkAdditionOfDirparRecommendationData(id) {
      const payload = {
        id: decodeURIComponent(id)
      };

      const endpoint = this.apiConfig.common_module.appManagement
        .getRecommendationDataOnAdditionDP;

      return new Promise(resolve => {
        baseService(
          endpoint,
          payload,
          ({ data: { data } }) => resolve(data.remarks),
          () => resolve(null),
          this.headerOptions
        );
      });
    }
  }
};
</script>

<style></style>
